import React from 'react';
import {
  Box,
  Typography,
} from '@material-ui/core';

import Button from 'src/components/Button';
import { archiveEngagement } from 'src/utils/api';

import useGetRequest from '../../../../hooks/useGetRequest';
import { getEngagementName } from '../../utils';

const SendNotificationHandler = ({
  triggeredAction,
  engagementId,
  taskId,
  onSuccess,
  onDismiss
}: any) => {
  const { result: engagement, isLoading } = useGetRequest({
    url: `/automatic/engagements/${engagementId}/`,
  });

  if (isLoading) return null;

  const engagementName = getEngagementName(engagement);

  const handleArchiveEngagement = () => {
    archiveEngagement(triggeredAction.event.engagementId).then(() => onSuccess(`${engagementName} archived.`));
  };

  return (
    <Box display="flex" alignItems="center" flexDirection="column" justifyContent="center" flexGrow="1">
      <Box display="flex" alignItems="center">
        <Typography variant="h3">
          Archive {engagementName}?
        </Typography>
      </Box>
      <Box display="flex" mt={2} justifyContent="space-between">
        <Button onClick={onDismiss}>
          Dismiss
        </Button>
        <Box ml={2}>
          <Button look="primary" onClick={handleArchiveEngagement}>
            Confirm
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default SendNotificationHandler;
